<template>
  <b-dropdown
    size="sm"
    variant="link"
    no-caret
    toggle-class="p-0"
    menu-class="event-stamp-dropdown">
    <template #button-content>
      <b-button
        variant="primary"
        class="toggle-button"
        size="sm">
        スタンプ
      </b-button>
    </template>
    <b-dropdown-item-button
      v-for="option in options"
      :key="option.value"
      button-class="d-flex align-items-center"
      @click="$emit('change', option.value)">
      <b-form-checkbox
        :checked="value === option.value"
        aria-readonly
        class="mr-n2" />
      <event-stamp
        :value="option.value"
        class="ml-2" />
    </b-dropdown-item-button>
  </b-dropdown>
</template>

<script>
import EventStamp from '@/components/parts/EventStamp.vue'
import { stampOptions } from '@/helper/stamps'

export default {
  components: {
    EventStamp
  },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    options() {
      return stampOptions
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle-button {
  height: 24px;
  padding: 4px;
  box-shadow: 1px 2px 6px $grey05;
  font-size: $fs-s;
}
</style>

<style lang="scss">
.event-stamp-dropdown {
  min-width: 70px !important;
}

.dropdown-item {
  padding: 4px 8px !important;
}
</style>